export default{
    //BASE PARAMS
    isForm: true,
    submitLoading: false,
    formMessage: "",
    formMessageType: "",
    isFormMessage: false,
    value : 0,
    //STEPS 
    step : 1,
    stepCount : 1,
    timeElapsed : 1,
    //DATA FETCH
    dataPost: {
        'csrf': null,
        'hiddenValue': {}
    },
    baseUrl: "https://api.shippoll.ir/api/v1/survey",
    // baseUrl: "http://192.168.50.185:8081/api/v1/survey",
    url: "",
    urlUpload: "",
    dataGet: { },
    alerts: { },
    settings: { },
    reviewField:{},   
}